import React from 'react';
import { formatEnumValue } from 'formatters';
import { Chip, Typography } from '@mui/material';
import { ChipOwnProps } from '@mui/material/Chip/Chip';

import { CreditSubmissionChangeType } from '../../../api';

const CHANGE_TYPE_COLOR_MAP: Record<CreditSubmissionChangeType, ChipOwnProps['color']> = {
  APPROVAL_TERMS: 'info',
  CONDITIONS_FEES: 'warning',
  DECISION_STATE: 'secondary',
  INITIAL_CREATION: 'success',
};

interface ChangeTypeChipProps {
  changeType: CreditSubmissionChangeType;
}

export const ChangeTypeChip = ({ changeType }: ChangeTypeChipProps) => {
  const color = CHANGE_TYPE_COLOR_MAP[changeType] ?? 'default';

  return (
    <Chip size="medium" label={<Typography>{formatEnumValue(changeType)}</Typography>} color={color} variant="filled" />
  );
};
